/*
 * Public API Surface of batch-autocomplete-lib
 */

export * from './lib/batch-autocomplete-lib.service';
export * from './lib/batch-autocomplete-lib.component';
export * from './lib/autocomplete/autocomplete.component';
export * from './lib/batch-autocomplete-lib.module';
export * from './lib/autocomplete/highlight.pipe';

